export const commonBG = {
    first: "Първи",
    second: "Втори",
    third: "Трети",
    fourth: "Четвърти",
    fifth: "Пети",
    sixth: "Шести",
    seventh: "Седми",
    eighth: "Осми",
    other: "Други",
    freeGift: "Безплатен подарък",
  "firstName": "Име",
  "lastName": "Фамилия",
  "street": "Улица",
  "streetNumber": "Номер",
  "city": "Град",
  "origin": "Регион",
  "postcode": "Пощенски код",
  "phone": "Телефонен номер",
  "apartment": "Апартамент",
  "email": "Имейл",
  "emailMessage": "Никога няма да споделим вашия имейл с никого",
  "checkout": "Плащане",
  "streetAndNumber": "Улица и номер",
  "privacyStatement": "Декларация за поверителност",
  "termsOfService": "Общи условия",
  "termsOfServiceNoun": "Общи условия",
  "aboutUs": "За нас",
  "product": "Продукт",
  "products": "Продукти",
  "subTotal": "Междинна сума",
  "transportation": "Цена на доставка",
  "total": "Общо",
  "price": "Цена",
  "quantity": "Количество",
  "items": "Артикули",
  "firstNameError": "Моля, въведете име",
  "lastNameError": "Моля, въведете фамилия",
  "phoneError": "Моля, въведете валиден телефонен номер",
  "emailError": "Моля, въведете валиден имейл",
  "save": "ЗАПАЗИ",
  "updateSuccess": "Актуализацията беше успешна",
  "updateError": "Грешка при актуализация",
  "updated": "Актуализирано!",
  "cartUpdated": "Успешно актуализирахте вашата количка!",
  "wishlistUpdated": "Успешно актуализирахте вашия списък с желания!",
  "streetError": "Моля, въведете улица",
  "streetNumberError": "Моля, въведете номер на улица",
  "cityError": "Моля, въведете град",
  "order": "Поръчка",
  "logout": "Изход",
  "warning": "ПРЕДУПРЕЖДЕНИЕ",
  "logoutWarning": "Сигурни ли сте, че искате да излезете?",
  "yes": "ДА",
  "no": "НЕ",
  "loginRegistration": "Вход/Регистрация",
  "login": "ВХОД",
  "passwordHelperText": "минимум 8 символа, включително цифри, главни и малки букви",
  "forgotPassword": "Забравена парола?",
  "or": "или",
  "facebookLogin": "ВХОД С FACEBOOK",
  "googleLogin": "ВХОД С GOOGLE",
  "register": "Регистрация",
  "registerButton": "НОВ КЛИЕНТ",
  "exit": "ИЗХОД",
  "resetPassword": "Нулиране на парола",
  "resetPasswordInfoA": "Моля, въведете вашия имейл",
  "resetPasswordInfoB": "и ще получите нова парола.",
  "registerA": "РЕГИСТРАЦИЯ",
  "registerInfoA": "С моята регистрация приемам",
  "registerInfoB": "общите условия",
  "registerInfoC": "и",
  "registerInfoD": "Декларацията за поверителност",
  "registerInfoE": "както и",
  "registerInfoF": "условията за офертите",
  "verificationCode": "Код за потвърждение",
  "verificationInfo": "Моля, въведете 4-цифрения код, изпратен на:",
  "enterCode": "Въведете код",
  "errorCode": "Грешен код за потвърждение. Моля, опитайте отново.",
  "codeExpired": "Този код е изтекъл или е опитван твърде много пъти. Поискайте нов.",
  "codeTooSoon": "Току-що беше изпратен код. Моля, изчакайте минута, преди да поискате нов.",
  "codeLocked": "Твърде много опити за този имейл. Моля, опитайте отново по-късно.",
  "codeEmailTaken": "Вече съществува акаунт с този имейл. Влезте или възстановете паролата си.",
  "codeAlreadyDone": "Акаунтът ви е готов. Моля, влезте.",
  "codeResent": "Изпратен е нов код на вашия имейл.",
  "codeSendLimit": "За тази регистрация не могат да се изпращат повече кодове. Въведете последния получен код или се регистрирайте отново.",
  "codeRegisterAgain": "Тази регистрация вече не е валидна. Моля, регистрирайте се отново.",
  "codeNoAnswer": "Няма отговор от магазина. Проверете връзката си и опитайте отново.",
  "repeat": "ИЗПРАТИ ОТНОВО",
  "youSee": "Виждате",
  "from": "от",
  "stockWarning": "За съжаление избраният от вас продукт е изчерпан!",
  "leaveAComment": "Оставете коментар...",
  "saveReview": "Запази ревюто",
  "reviews": "Ревюта",
  "qrCodeBuy": "Купете бързо и лесно с едно кликване от вашия мобилен!",
  "qrCodeScanAndroid": "Сканирайте, за да изтеглите нашето приложение за Android",
  "qrCodeDownload": "Изтеглете нашето приложение за Android",
  "qrCodeBuyMobile": "За Android и iOS, изтеглете нашето ресторантско приложение и поръчвайте по всяко време от вашия мобилен!",
  "qrCodeScanIos": "Сканирайте, за да изтеглите нашето приложение за iOS",
  "qrCodeForAndroid": "За Android",
  "qrCodeForIos": "За iOS",
  "photoUpload": "Качване на снимка",
  "edit": "РЕДАКТИРАЙ",
  "delete": "ИЗТРИЙ",
  "addCart": "Добави в количката",
  "noEvaluation": "Все още няма оценки.",
  "onlyLoggedInCustomers": "Само влезли клиенти, които са закупили продукта, могат да пишат ревюта.",
  "beTheFirstReview": "Бъдете първият, който пише ревю за този продукт.",
  "seeMoreProducts": "Вижте още продукти",
  "favorite": "ЛЮБИМИ",
  "favorites": "Любими",
  "noFavoritesYet": "Все още нямате любими продукти",
  "deleteProduct": "Сигурни ли сте, че искате да премахнете този продукт?",
  "deleteProduct1": "Сигурни ли сте, че искате да премахнете този продукт",
  "fromCart": "от количката?",
  "deleteAddress": "Сигурни ли сте, че искате да изтриете адреса?",
  "danger": "ПРЕДУПРЕЖДЕНИЕ",
  "connectionIssue": "Внимание! Изпращането на поръчката не беше успешно. Моля, проверете връзката си.",
  "sendOrder": "Изпрати поръчка",
  "pleaseWait": "Моля, изчакайте...",
  "noMoreProductsInStock": "Не можете да добавите в количката повече продукти, отколкото има в наличност",
  "productAddedCart": "Продуктът е добавен във вашата количка!",
  "home": "Начало",
  "myAccount": "Моят акаунт",
  "ckeckout": "ПЛАЩАНЕ",
  "all": "Всички",
  "signIn": "Вход",
  "search": "Търсене",
  "productSKU": "SKU",
  "productSKUFull": "SKU на продукта:",
  "language": "Език",
  "size": "РАЗМЕР",
  "extra": "Допълнително",
  "removeIngredients": "Премахване на съставки",
  "status": "Статус",
  "searchResults": "Резултати от търсенето",
  "noResults": "НЯМА РЕЗУЛТАТИ",
  "dailyProducts": "Ежедневни продукти",
  "offersText": "Ежедневни оферти",
  "popularText": "Най-популярни",
  "productComments": "Въведете коментар или специална нужда (по избор)",
  "weighted": "Претеглен продукт",
  "kgr": "Цена за кг",
  "without": "БЕЗ",
  "noSuchUser": "Няма потребител с този имейл!",
  "reset": "Нулиране.",
  "lostPassword": "Забравена парола? ",
  "loginOr": "или влезте с",
  "here": "тук",
  "orRegister": "Нямате акаунт? Регистрирайте се ",
  "stockWarningHeader": "Предупреждение за наличност",
  "duplicateEmail": "Този имейл се използва от друг акаунт. Моля, опитайте да влезете.",
  "cartUpdatedAlert": "Количката е актуализирана",
  "wishlistUpdatedAlert": "Списъкът с желания е актуализиран",
  "watchThis": "Вижте тези!",
    composition: "Състав",
  "pickSize": "Изберете размер",
  "addExtra": "Добавете допълнителни съставки",
  "logoutAccount": "Изход от акаунта",
  "deleteAccount": "Изтриване на акаунта",
  "deleteAccountMessage": "Наистина ли искате да изтриете акаунта си?",
  "yesSmall": "Да",
  "noSmall": "Не",
  "show": "Покажи количката",
  "removeItem": "Премахни артикул",
  "youSure": "Сигурни ли сте?",
  "cancel": "Отказ",
  "scannerError": "Грешка при сканиране. Моля, опитайте отново.",
  "scannerSuccess": "Добре дошли",
  "scannerMessage": "Продължете като гост на вашата маса",
  "companyOrigin": "Основен регион",
  "addNewAddress": "Добавяне на нов адрес",
  "holidayText": "Заведението ще остане затворено днес",
  "minimumOrderHeader": "Минимална поръчка",
  "minimumOrder": "Минималната поръчка е ",
  "appleId": "Този имейл е използван за вход с Apple",
  "facebookId": "Този имейл е използван за вход с Facebook",
  "googleId": "Този имейл е използван за вход с Google",
  "emailPassword": "Този имейл е използван за вход с имейл и парола",
  "loginError": "Грешка при вход: ",
  "discount": "Отстъпка",
  "to": "Отворено до",
  "openingTime": "Работно време",
  "more": "Още",
  "lastAddress": "Не може да изтриете последния адрес",
  "updateFailure": "Неуспешно актуализиране",
  "succesDeleteAddress": "Адресът беше успешно изтрит.",
  "noCategoryItemsYet": "Все още няма активни продукти в тази категория.",
  "reserveTable": "Резервирайте маса",
  "reserveTableUC": "РЕЗЕРВИРАЙТЕ МАСА",
  "yourReservation": "Вашата резервация",
  "chooseHour": "Изберете час",
  "bookingComment": "Добавете специална заявка (по избор)",
  "party": "Група",
  "pickDate": "Изберете дата",
  "partyOf": "Група от ",
  "date": "Дата",
  "hour": "Час",
  "customerDiscount": "Клиентска отстъпка",
  "couponDiscount": "Отстъпка с купон",
  "voucherTitle": "Спечелихте купон на стойност ",
  "applyVoucher": "Приложете този купон към вашата количка.",
  "copy": "Копирай",
  "minimumVoucherOrder": "Минимална поръчка",
  "minimumVoucherCaption": "Минималната поръчка, необходима за прилагане на отстъпката, е",
  voucherNotApplied: "Купонът не е приложен",
  voucherInvalid: "Този код не е валиден.",
  voucherExpired: "Този код е изтекъл.",
  voucherFirstOrderOnly: "Валиден само за първата ви поръчка, с акаунт.",
  "loyaltyTitle": "Награди за лоялност",
  "loyaltyCaption": "Спечелихте награди за лоялност на обща стойност",
  "loyaltySubCaption": "Те ще бъдат приспаднати автоматично при плащането.",
  "loyaltyMoto": "Продължавайте да поръчвате, за да печелите отстъпки",
  "endsIn": "Свършва след",
  "days": "дни",
  "table": "МАСА",
  "comments": "КОМЕНТАРИ",
  "dateCut": "Дата",
  "newOrder": "НОВА ПОРЪЧКА",
  "num": "С/Н",
  "extras": "ДОПЪЛНИТЕЛНО",
  "tableOrder": "МАСА",
  "phoneDelivery": "ТЕЛЕФОННА ДОСТАВКА",
  "phoneTakeAway": "ТЕЛЕФОНЕН ВЗЕМАЊЕ",
  "webDelivery": "УЕБ ДОСТАВКА",
  "webTakeAway": "УЕБ ВЗЕМАЊЕ",
  "webTable": "УЕБ-QR МАСА",
  "appDelivery": "АП ДОСТАВКА",
  "appTakeAway": "АП ВЗЕМАЊЕ",
  "appTable": "АП-QR МАСА",
  "enterTip": "Въведете бакшиш",
  "tip": "Бакшиш",
  "apply": "Приложи",
  "textTotal": "Общо плащане",
  "successfulPayment": "Успешно плащане",
  "unsuccessfulPayment": "Неуспешно плащане",
  "payment": "Плащане",
  "confirmation": "Потвърждение",
  "tryAgain": "Опитайте отново",
  "appliedDiscounts": "Приложени отстъпки",
  "productName": "Име на продукта",
  "totalPrice": "Обща цена",
  "firstname": "Име",
  "lastname": "Фамилия",
  "postCode": "Пощенски код",
  "invoiceAddress": "Адрес за фактура",
  "otherAddress": "Адрес за доставка",
  "afm": "ДДС номер",
  "doy": "Данъчна служба",
  "occupation": "Професия",
  "invoiceData": "Данни за фактура",
  "yourOrder": "Вашата поръчка от",
  "withNumber": "с номер",
  "dear": "Уважаеми г-н/г-жо",
  "orderTotalAmount": "Общата сума на вашата поръчка е",
  "orderDelivery": "Вашата поръчка ще бъде доставена много скоро.",
  "thanks": "Благодарим ви, че избрахте",
  "customer": "Клиент",
  "youReceived": "Получихте следната поръчка с номер",
  "congrats": "Поздравления за поръчката",
  "newOrderWith": "Нова поръчка с номер",
  "orderingComments": "Коментари към поръчката",
    "selectSmall": "Избери",
 delivery: "Доставка",
     "course": "Курс",
     view: "Преглед",
     "outOfStock": "Няма наличност",
    emailConfirmationCode: "Код за потвърждение",
    emailCodeIs: "Вашият 4-цифрен код за потвърждение е",
    emailPasswordReset: "Нулиране на парола",
    emailNewPassword: "Вашата нова парола е",
    emailLoginInfo: "Можете да влезете с имейла и новата си парола",
    emailChangePassword: "След това можете да я промените с ваша собствена",
    partOf: "Част от",
    errorTitle: "Нещо се обърка",
    errorMessage: "Тази страница срещна неочаквана грешка. Можете да опитате отново или да се върнете към началната страница.",
    goToHome: "Към началната страница",
    colorThemeLight: "Светла тема",
    colorThemeDark: "Тъмна тема",
    colorThemeSystem: "Системна тема",
    skipToContent: "Преминаване към съдържанието",
    mainMenu: "Главно меню",
    grams: "g",
    addressTooFar: "Този адрес изглежда твърде далеч от заведението — моля, проверете го.",
    addressPickArea: "Адресът е намерен — моля, изберете вашия район по-долу.",
    addressLookupFailed: "Адресът не можа да бъде разчетен, моля, въведете го ръчно.",
    trackOrder: "Проследи поръчката",
    orderStatus: "Статус на поръчката",
    trackingUnavailable: "Проследяването на живо не е налично за тази поръчка.",
    courierEnRoute: "Куриерът е на път",
    courierLastSeen: "Куриерът е видян за последно в",
    courierNoPosition: "Вашата поръчка е при куриер.",
    orderStatusPending: "В изчакване",
    orderStatusProcessing: "Приготвя се",
    orderStatusCompleted: "Готова",
    orderStatusDelivering: "В процес на доставка",
    orderStatusDelivered: "Доставена",
    adjustPinHint: "Плъзнете маркера до вашия точен вход",
    updateAddress: "Актуализирай адреса",
    addressPinSaved: "Местоположението е актуализирано.",
    paymentUnconfirmedTitle: "Плащането все още не е потвърдено",
    paymentUnconfirmed: "Все още не успяхме да потвърдим плащането ви с банката, затова поръчката ви не е изпратена. Повторният опит само проверява отново - картата ви няма да бъде таксувана повторно.",
    paymentNotVerified: "Плащането с карта не можа да бъде потвърдено, затова поръчката не беше направена.",
}